import { useCallback } from 'react';

import { useConversion } from './crypto/useConversion';

const useCurrency = () => {
  const query = useConversion({
    convert: ['USD'],
    symbol: 'ETH',
  });

  const ethUsd = query.data?.[0].quote.USD.price;

  const convertEthToUsd = useCallback(
    (amount: number | undefined) => {
      return ethUsd && amount ? Number((amount * ethUsd).toFixed(2)) : 0;
    },
    [ethUsd]
  );

  return { ...query, convertEthToUsd };
};

export default useCurrency;
